import { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import getBackendUrl from "../../../environment/BackendService";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { useRBAC } from "../../../common_nextgen/hooks/RBACContext";


const useDeductibleScheduleNotes = () => {
    const {writeAccess} = useRBAC();
    const { axios_helper_no_header } = useAxios();
    const {DEDUCTIBLE_SCHEDULE} = ROUTE_PATHS;
    const location = useLocation();
    const { state: stateVal } = location;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    console.log("current state in form", currentState, previousState);
    const {
        selectedSchedules = [],
        previousScreen = DEDUCTIBLE_SCHEDULE,
        currentIndex: initialIndex = 0,
    } = currentState;
    console.log("sel sch", selectedSchedules);
    const [notes, setNotes] = useState([]);
    const [newNotes, setNewNotes] = useState([""]);
    const [mode, setMode] = useState("view"); // 'view' or 'add'  
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const toast = useToast();


    const initializeProgram = async () => {
        const page = first / rows;
        try {
            if (mode === 'view') {
                const dscScheduleName = selectedSchedules[currentIndex].dscScheduleName;
                const params = {
                    dscScheduleName: dscScheduleName,

                    page: page,
                    size: rows
                };
                const notesResponse = await axios_helper_no_header(
                    "GET",
                    "api/dsnDeductSchCtlNotes",
                    {},
                    params
                );
                if (notesResponse && notesResponse.responseData) {
                    console.log(notesResponse,"agam")
                    setNotes(notesResponse.responseData);
                    setTotalRecords(notesResponse.responsePaginationDTO.totalRecords);
                    if (writeAccess && notesResponse.responsePaginationDTO.totalRecords === 0) {
                        setMode("add");
                    }
                } else {
                    console.error("Unexpected response structure:", notesResponse);
                }
            }
        } catch (error) {
            console.error("Initialization failed:", error);
        }
    };

    useEffect(() => {
        initializeProgram();
    }, [first, rows, currentIndex, selectedSchedules, mode]);

    useEffect(() => {
        setNewNotes(Array(rows).fill(''));
        setFirst(0);
    }, [mode, rows]);

    const handleSaveNotes = async (formData) => {
        try {
            const updatedNotes = formData
                .filter((note) => (String(note).trim() !== "" && note !== undefined))
                .map((note) => ({
                    dscScheduleName: selectedSchedules[currentIndex].dscScheduleName,
                    dsnNote: note,
                    screenNumber: "RCDSN001"
                }));
  
            const response = await axios_helper_no_header(  
                "POST",  
                "api/dsnDeductSchCtlNotes",  
                updatedNotes,  
                {}  
            );  
  
            setNotes([...updatedNotes, ...notes]);  
            setNewNotes([""]);  
            setMode("view");  
        } catch (error) {  
            console.error("Save notes failed:", error);  
            toast.current.show({  
                severity: "error",  
                summary: "",  
                detail: error.message,  
                life: 3000,  
            });  
        }  
    };  
  
    const handleChangeNewNote = (index, value) => {  
        const updatedNotes = [...newNotes];  
        updatedNotes[index] = value;  
        setNewNotes(updatedNotes);  
    };  
  
    const onPageChange = (event) => {  
        setFirst(event.first);  
        setRows(event.rows);  
        setNewNotes(Array(rows).fill(''));  
    };   

    const exportAsCSV = async () => {
        let params = {  
            dscScheduleName:selectedSchedules[currentIndex].dscScheduleName  
        };
        const queryParams = new URLSearchParams({ ...params });
        try {
          const response = await axios_helper_no_header(
            "GET",
            "api/dsnDeductSchCtlNotes/exportCsv",
            null,
            queryParams,
            "blob"
          );
          downloadCSV(response);
        } catch (error) {
          console.error("Error exporting as CSV:", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: "Failed to export CSV. Please try again.",
            life: 3000,
          });
        }
      };
  
    return {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    };  
};  
  
export default useDeductibleScheduleNotes;  
